module.exports = __webpack_public_path__ + "static/media/logo_2.e8384d09.png";